import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { usePublicWorkflowBySlug } from "@/queries/workflowQueries";
import { useWorkflowContext } from "@/contexts/WorkflowContext";
import LoadingScreen from "@/components/LoadingScreen";
import { ErrorInfo } from "@/components/ErrorInfo";
import { useAuth } from "@/contexts/AuthContext";

export const HydratePublicWorkflow = ({ children }: { children: React.ReactNode }) => {
    const { shareableSlug } = useParams<{ shareableSlug: string }>();
    const { guestAuthInitialized } = useAuth();
    const { data, isLoading, error, refetch } = usePublicWorkflowBySlug(
        shareableSlug,
        guestAuthInitialized
    );
    const { setCurrentWorkflow } = useWorkflowContext();

    useEffect(() => {
        setCurrentWorkflow(data ?? null);
        return () => setCurrentWorkflow(null);
    }, [data, setCurrentWorkflow]);

    if (error) {
        return (
            <div className="flex h-full items-center justify-center p-4">
                <ErrorInfo error={error.message} onRetryClick={() => refetch()} />
            </div>
        );
    }

    if (!guestAuthInitialized || isLoading || !data) {
        return <LoadingScreen />;
    }

    return <>{children}</>;
};
